import React, { useState } from "react";
import Swal from "sweetalert2";
import { Api } from "../Api/Api";

export default function BuyerInfoForm() {
  const [formData, setFormData] = useState({
    companyName: "",
    gstNumber: "",
    ownerName: "",
    email: "",
    address: "",
    contactNumber: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${Api}company/post.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.message || "Company info saved successfully!",
        });
        // reset form
        setFormData({
          companyName: "",
          gstNumber: "",
          ownerName: "",
          email: "",
          address: "",
          contactNumber: "",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "Failed to save company info.",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while saving company info.",
      });
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 p-6 bg-white shadow rounded">
      <h2 className="text-2xl font-semibold mb-6 text-center">Company Info</h2>

      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* LEFT COLUMN */}
          <div className="space-y-4">
            <div>
              <label className="block mb-1 font-medium" htmlFor="companyName">
                Company Name
              </label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                required
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Enter company name"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium" htmlFor="gstNumber">
                GST Number
              </label>
              <input
                type="text"
                id="gstNumber"
                name="gstNumber"
                required
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={formData.gstNumber}
                onChange={handleChange}
                placeholder="Enter GST number"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium" htmlFor="ownerName">
                Owner Name
              </label>
              <input
                type="text"
                id="ownerName"
                name="ownerName"
                required
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={formData.ownerName}
                onChange={handleChange}
                placeholder="Enter owner name"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium" htmlFor="ownerName">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter email"
              />
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="space-y-4 flex flex-col h-full">
            <div>
              <label className="block mb-1 font-medium" htmlFor="address">
                Address
              </label>
              <textarea
                id="address"
                name="address"
                required
                rows={4}
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter address"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium" htmlFor="contactNumber">
                Contact Number
              </label>
              <input
                type="tel"
                id="contactNumber"
                name="contactNumber"
                required
                pattern="[0-9]{10}"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={formData.contactNumber}
                onChange={handleChange}
                placeholder="Enter 10-digit contact number"
              />
            </div>
            <div className="mt-auto">
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 transition"
              >
                {loading ? "Saving..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
